import { PowerBIReportComponent } from './powerbi-report';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [PowerBIReportComponent],
  exports: [PowerBIReportComponent],
})
export class PowerBIReportModule {}
